import "./footer.css"

import { Link } from "react-router-dom"

import footerLogo from "../../../assets/general_assets/Transparent logo.png"

export default function Footer() {

    return (

        <>
            <footer id="footer">
                <div className="socials">
                    <p style={{ color: "#fff", fontSize: "25px", fontWeight: "bold" }}>SOCIALS</p>
                    <div className="icons">
                        <Link to="https://linktr.ee/nomadicwaybjjretreat"><i id="linktree" class="bi bi-link-45deg"></i></Link>
                        <Link to="https://www.instagram.com/nomadicwaybjjretreat?igsh=NjJzOW81bHZyMWN2"><i id="instagram" class="bi bi-instagram"></i></Link>

                    </div>
                    <img id="footerImg1" alt="Nomadic Way" src={footerLogo} />
                </div>
                <div className="Contact">
                    <p style={{ color: "#fff", fontSize: "25px", fontWeight: "bold"}}>CONTACTS</p>
                    <p style={{ color: "#fff", fontSize: "15px"}}>nomadicwaybjj@gmail.com</p>
                </div>
                <img id="footerImg2" alt="Nomadic Way" src={footerLogo} />

            </footer>
        </>

    )

}